export default {"src":"/_next/static/media/plus.65034d9b.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};